import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navigation.module.scss';

import { getTranslation } from '../../../utils/translation';

export default function Navigation() {
    return (
        <nav>
            <ul className={styles.menu}>
                <li className={styles.menuItem}>
                    <NavLink to='/app/sports' activeClassName={styles.active}>
                        {getTranslation('menu.sports')}
                    </NavLink>
                </li>
                <li className={`${styles.menuItem} ${styles.live}`}>
                    <NavLink to='/app/live' activeClassName={styles.active}>
                        {getTranslation('menu.live')}
                    </NavLink>
                </li>
                <li className={`${styles.menuItem} ${styles.hasSubMenu}`}>
                    <NavLink
                        to='/app/e-sports'
                        isActive={(match, location) => location.pathname.includes('/app/e-')}
                        activeClassName={styles.active}
                    >
                        {getTranslation('menu.e-sports')}
                    </NavLink>
                    <ul className={styles.subMenu}>
                        <li className={styles.menuItem}>
                            <NavLink to='/app/e-sports' activeClassName={styles.active}>
                                {getTranslation('menu.prematch')}
                            </NavLink>
                        </li>
                        <li className={styles.menuItem}>
                            <NavLink to='/app/e-live' activeClassName={styles.active}>
                                {getTranslation('menu.live')}
                            </NavLink>
                        </li>
                    </ul>
                </li>
                <li className={styles.menuItem}>
                    <NavLink to='/app/results' activeClassName={styles.active}>
                        {getTranslation('menu.results')}
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
}
